<template>
  <div>
    <div class="baHeight">
      <el-carousel
        :interval="5000"
        arrow="hover"
        id="banner"
        
        :height="height"
        class="banner"
      >
        <el-carousel-item v-for="(item, index) in banners" :key="index">
          <img class="bannerImage" :src="item.imagsUrl" @click="bannerAction(item)" />
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>
<script>
import { api } from '../../assets/api/axios'
export default {
  data() {
    return {
      banners: [
      ],
      height: '',
    }
  },
  created() {
    this.getBanner()
  },
  beforeMount: function () {
    let _w = document.documentElement.clientWidth || document.body.clientWidth
    this.height = (_w * 400) / 1920 + 'px'
  },
  methods: {
    bannerAction(data){
      if (data.skipUrlPortal) {
        window.open(data.skipUrlPortal);
      }else{
        
      }
    },
    async getBanner() {
      const { data: res } = await api.get(
        `/common/business/advertisingspace/list?issueType=2&type=1`
      )
      this.banners = res
    },
  },
}
</script>
<style>
.banner img {
  width: 100%;
  object-fit:cover;
}
.carousel-indicators .active {
    width: 48px;
    height: 48px;
    margin: 10px;
    background-color: #ffff99;
}
.el-carousel__indicator.is-active button{
  background-color: #0082F0 !important;
}
.banner .el-carousel__button{
  width: 24px !important;
  height: 5px !important;
  opacity: 1 !important;
  margin-right: 7px !important;
}
</style>
<style lang="scss" scoped>

.baHeight {
}
.img {
  width: 100%;
  height: 100%;
}
</style>

